import {
  DateFormatPreference,
  DEFAULT_DATE_FORMAT_PREFERENCE,
} from "@/enums/date-format";
import {
  formatIsoDateHourShort,
  formatIsoDateParts,
  formatIsoDateTimeFull,
  formatIsoDateTimeSeparate,
  formatIsoDateTimeShort,
} from "@/utils/date-format-config";

export const DateFormatterDDMMYYYY = (
  date: string,
  preference: DateFormatPreference = DEFAULT_DATE_FORMAT_PREFERENCE,
) => formatIsoDateTimeFull(date, preference);

export const SeparateDateFormatterDDMMYYYY = (
  date: string,
  preference: DateFormatPreference = DEFAULT_DATE_FORMAT_PREFERENCE,
) => formatIsoDateTimeSeparate(date, preference);

export const DateFormatter = (
  dateTime: string,
  preference: DateFormatPreference = DEFAULT_DATE_FORMAT_PREFERENCE,
) => formatIsoDateParts(dateTime, preference);

export const DateFormatterShort = (
  date: string,
  preference: DateFormatPreference = DEFAULT_DATE_FORMAT_PREFERENCE,
) => formatIsoDateTimeShort(date, preference);

export const DateHourFormatterShort = (
  date: string,
  preference: DateFormatPreference = DEFAULT_DATE_FORMAT_PREFERENCE,
) => formatIsoDateHourShort(date, preference);
